import React, { useState, useCallback, useContext, useEffect } from "react";
import "./header.css";
import { AiFillStar } from "react-icons/ai";
import { RiArrowRightSLine } from "react-icons/ri";
import coin from "../../assets/Coin.png";
import logo from "../../assets/logo.png";
import { Web3ModalContext } from "../../contexts/Web3ModalProvider";
import { Web3WrapperContext } from "contexts/Web3WrapperProvider";
import { useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../hooks/redux";
import { setDashboard } from "../../store/reducers/DashboardSlice";

import "./navbar.scss";
import MenuIcon from '@mui/icons-material/Menu';

function Index() {
  const navigate = useNavigate();
  const [currentState, setCurrentState] = useState(0);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [items, setItems] = useState([
    { name: "Play" },
    { name: "Tournaments & Betsfff" },
    { name: "Stake Crace" },
    { name: "E-shop" },
    { name: "NFT Mint" },
    { name: "NFT Mutation" },
    { name: "NFT MarketPlace" },
  ]);
  const [totalGraceHave, setTotalGraceHave] = useState(0);

  const { web3Wrapper: wrapper } = useContext(Web3WrapperContext);

  const { connect, disconnect, account } = useContext(Web3ModalContext);

  const dispatch = useAppDispatch();
  const { dashboard } = useAppSelector((state) => state.DashboardReducer);
  let GraceValue=0;
  if(dashboard){
    GraceValue=dashboard.balance;
  }

  useEffect(() => {
     walletHandler();
   }, []);

   const walletHandler = useCallback(() => {
    //  alert("web");
      connect();
    }, [connect]);


  //console.log(dashboard);
  const getTokenAmount = async () => {
     dispatch(setDashboard(0));
    let crace = 0;
    if (dashboard) {
      crace = dashboard.balance;
    } else {
      crace = 0;
    }
   // console.log(crace);
    // let crace: any = await wrapper?.getBalanceofCoin(account);
    // crace = crace / 1000000000000000000;
    // crace = Math.round(crace, 2);
    setTotalGraceHave(crace);
  };
  useEffect(() => {
    getTokenAmount();
  }, [wrapper]);

  useEffect(() => {
    getTokenAmount();
  }, [GraceValue]);




  //console.log(account);
  if(account){
    localStorage.setItem("hjk", "1");
  }else{
    localStorage.setItem("hjk", "0");
  }


  return (

    <div className="navbar">
    <div className="wrapper">
      <div className="logo1">
        <img height="40px" src="images/logo.png" alt="" />
      </div>
      <button type="button" id="sidebarCollapse" className="btn btn-light">
        <MenuIcon />
        <span >Toggle Sidebar</span>
      </button>
      <div className="bg-img">
        <img width="800px" src="images/News.png" alt="" />
        <p className="text-postion-nav mb-0">Coinracer Reloaded seed phase FINISHED!!!</p>
      </div>
      <div style={{paddingRight:"30px"}} className="nav-balance ml-5">
        <p className="p-1 m-0 "> CRACE Balance </p>
        <p style={{float:"right", fontSize:"16px"}} className="p-2 mb-0 ">{totalGraceHave.toFixed(2)}</p>
      </div>
    
    </div>
  </div>

  );
}

export default Index;
